/*
 * ParfumLab 360 tasarımı: ürün sayfası.
 * - Adet seçici (− 1 +): seçilen adet formdaki gizli "quantity" alanına yazılır; sepete ekleme temanın
 *   product-form bileşeniyle yapılır.
 * - Galeri etiketi (ör. 1 / 7): temanın galeri kodu data-plr-current'ı "01" biçiminde günceller; etiket
 *   tasarımdaki gibi sıfırsız gösterilir.
 * - Ten Kayıtları: dağılım satırına dokununca o puandaki yorumlar (tekrar dokununca ya da "Tümünü göster"
 *   ile hepsi), "En yeni / En yüksek puan / En düşük puan" sıralaması (snippets/pl-pdp-reviews).
 */
(() => {
  if (window.plr360Pdp) return;
  window.plr360Pdp = true;

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-plr-qty-step]');
    if (!step) return;
    const box = step.closest('[data-plr-qty]');
    const input = box && box.querySelector('input[name="quantity"]');
    if (!input) return;
    event.preventDefault();
    const value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(step.dataset.plrQtyStep)));
    input.value = value;
    const out = box.querySelector('[data-plr-qty-value]');
    if (out) out.textContent = value;
    const minus = box.querySelector('[data-plr-qty-step="-1"]');
    if (minus) minus.disabled = value <= 1;
    const plus = box.querySelector('[data-plr-qty-step="1"]');
    if (plus) plus.disabled = value >= 99;
  });

  const reviewState = (block) => {
    const list = block.querySelector('[data-plr-review-list]');
    if (!list) return;
    const filter = Number(block.dataset.filter || 0);
    const sort = block.querySelector('[data-plr-review-sort]')?.value || 'new';
    const records = Array.from(list.querySelectorAll('[data-rating]'));
    records.sort((a, b) => {
      const ra = Number(a.dataset.rating), rb = Number(b.dataset.rating), oa = Number(a.dataset.order), ob = Number(b.dataset.order);
      if (sort === 'high') return rb - ra || oa - ob;
      if (sort === 'low') return ra - rb || oa - ob;
      return oa - ob;
    }).forEach((record) => list.appendChild(record));
    let shown = 0;
    records.forEach((record) => {
      const show = !filter || Number(record.dataset.rating) === filter;
      record.hidden = !show;
      if (show) shown += 1;
    });
    const empty = block.querySelector('[data-plr-review-empty]');
    if (empty) empty.hidden = shown > 0;
    const label = block.querySelector('[data-plr-review-label]');
    if (label) label.textContent = filter ? `${filter} yıldızlı değerlendirmeler` : 'Değerlendirmeler';
    const all = block.querySelector('.plr-review-controls [data-plr-review-filter="0"]');
    if (all) all.hidden = !filter;
    block.querySelectorAll('.plr-rating-row[data-plr-review-filter]').forEach((row) => row.setAttribute('aria-pressed', String(Number(row.dataset.plrReviewFilter) === filter)));
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-plr-review-filter]');
    const block = button && button.closest('[data-plr-reviews]');
    if (!block) return;
    const value = Number(button.dataset.plrReviewFilter);
    block.dataset.filter = Number(block.dataset.filter || 0) === value ? 0 : value;
    reviewState(block);
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-plr-review-sort]');
    const block = select && select.closest('[data-plr-reviews]');
    if (block) reviewState(block);
  });

  const syncGalleryLabels = () => {
    document.querySelectorAll('.plr-p360 [data-plr-current]').forEach((current) => {
      const label = current.parentElement && current.parentElement.querySelector('[data-plr360-index]');
      if (!label || current.plr360Synced) return;
      current.plr360Synced = true;
      /* Sayaç (ör. 1 / 7) yalnız görsel değişirken ve sayfa açılışında görünür; hareket bitince 2 sn sonra
         kaybolur (kullanıcı isteği, 29 Ekim). Görünürlük CSS'te: .plr-gallery__bar.is-count-visible */
      const bar = current.closest('.plr-gallery__bar');
      const gallery = current.closest('[data-plr-gallery]');
      const track = gallery && gallery.querySelector('[data-plr-track]');
      let hideTimer;
      const flash = () => {
        if (!bar) return;
        bar.classList.add('is-count-visible');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => bar.classList.remove('is-count-visible'), 2000);
      };
      const sync = () => { label.textContent = String(parseInt(current.textContent, 10) || 1); flash(); };
      new MutationObserver(sync).observe(current, { childList: true, characterData: true, subtree: true });
      if (track) track.addEventListener('scroll', flash, { passive: true });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGalleryLabels);
  else syncGalleryLabels();

  // Paylaş: dokunmatik cihazda paylaşım ekranı; masaüstünde bağlantı kopyalanır ve paylaşma seçenekleri açılır.
  const closeShare = () => {
    document.querySelectorAll('.plr-share-menu').forEach((menu) => menu.remove());
    document.querySelectorAll('[data-plr-pdp-share][aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };
  const openShare = (button, title, url, copied) => {
    closeShare();
    const enc = encodeURIComponent;
    const options = [
      ['WhatsApp', `https://wa.me/?text=${enc(url)}`],
      ['X', `https://twitter.com/intent/tweet?url=${enc(url)}`],
      ['Facebook', `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`],
      ['Telegram', `https://t.me/share/url?url=${enc(url)}`],
      ['E-posta', `mailto:?subject=${enc(title)}&body=${enc(url)}`],
    ];
    const menu = document.createElement('div');
    menu.className = 'plr-share-menu';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-label', 'Ürünü paylaş');
    menu.tabIndex = -1;
    const note = document.createElement('p');
    note.className = 'plr-share-menu__note';
    note.setAttribute('role', 'status');
    note.textContent = 'Bu formülü paylaş';
    const grid = document.createElement('div');
    grid.className = 'plr-share-menu__options';
    options.forEach(([name, href]) => {
      const a = document.createElement('a');
      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = name;
      a.addEventListener('click', () => setTimeout(closeShare, 0));
      grid.appendChild(a);
    });
    const copy = document.createElement('button');
    copy.type = 'button';
    copy.textContent = 'Bağlantıyı kopyala';
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(url); note.textContent = 'Bağlantı kopyalandı.'; }
      catch (error) { window.prompt('Ürün bağlantısı:', url); }
    });
    grid.appendChild(copy);
    menu.append(note, grid);
    button.insertAdjacentElement('afterend', menu);
    button.setAttribute('aria-expanded', 'true');
    menu.focus({ preventScroll: true });
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-plr-pdp-share]');
    if (!button) {
      if (!event.target.closest('.plr-share-menu')) closeShare();
      return;
    }
    event.preventDefault();
    if (button.getAttribute('aria-expanded') === 'true') return closeShare();
    const url = button.dataset.url || window.location.href.split('?')[0];
    const title = button.dataset.title || document.title;
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      // Yalnız bağlantı: önüne metin eklenince WhatsApp önizlemeyi küçük gösteriyor
      navigator.share({ url }).catch(() => {});
      return;
    }
    let copied = false;
    try { await navigator.clipboard.writeText(url); copied = true; } catch (error) { /* seçenekler yine açılır */ }
    openShare(button, title, url, copied);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !document.querySelector('.plr-share-menu')) return;
    const opener = document.querySelector('[data-plr-pdp-share][aria-expanded="true"]');
    closeShare();
    if (opener) opener.focus();
  });
})();
